<template>
    <div @click.prevent.stop="cmOpener.open($event, id)"
         :class="buttonClass">
        <i class="block text-center icon-opzioni"></i>
    </div>
    <teleport :to="teleport_to">
        <ContextMenu :id="id" :menu-class="menuClass" :cmOpener="cmOpener">
            <slot></slot>
        </ContextMenu>
    </teleport>

</template>

<script lang="ts">
import {Options} from 'vue-class-component';
import {Vue} from 'vue-class-component';
import ContextMenu from "@/components/ContextMenu.vue";
import Attivita from "@/views/Attivita.vue";
import ConfirmDelete from "@/components/ConfirmDelete.vue";

@Options({
    name:'TabellaContextMenu',
    components: {Attivita, ContextMenu, ConfirmDelete},
    inheritAttrs: false,
    props: {
        menuClass: {
            type: String,
            default: ''
        },
        buttonClass: {
            type: String,
            default: ''
        },
        teleport_to: {
            type: String,
            required:true
        },
        context: Object,
        id: {
            type: [String, Number],
            required: true
        },
        cmOpener: {
            type: Object,
            required: true
        }
    }
})

export default class TabellaContextMenu extends Vue {
}
</script>
